import axios from 'axios'
import HTTP from './http'

export default {
    getClinic: payload => axios.get(HTTP.CLINIC, { params: payload }),
    list: payload => axios.get(HTTP.CLINIC_LIST, { params: payload }),
    search: payload => axios.get(HTTP.CLINIC_SEARCH, { params: { ...payload } })
}
